import { Box } from '@chakra-ui/react';

interface StepHeaderProps {
  stepNumber: 1 | 2 | 3;
  title: string;
  isEnabled: boolean;
}

const StepHeader = ({ stepNumber, title, isEnabled }: StepHeaderProps) => {
  return (
    <Box textAlign="center">
      <Box
        fontSize="lg"
        fontWeight="bold"
        color={isEnabled ? 'brand.500' : 'gray.500'}
        mb="5px"
      >
        Step {stepNumber}
      </Box>
      <Box fontSize="md" fontWeight="semibold" mb="10px">
        {title}
      </Box>
    </Box>
  );
};

export default StepHeader;
